import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { AuthUser } from 'app/core/auth/core/auth-user.model';
import { AuthState } from 'app/core/auth/core/auth.state';
import { Observable } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { InscriptionQueryService } from '~app/inscription/store/cotisation-form/inscription-query.service';

@Injectable({
  providedIn: 'root',
})
export class UserMemberService {

  @Select(AuthState.user) user$: Observable<AuthUser>;

  public memberId$: Observable<string>;

  constructor(
    private inscriptionQueryService: InscriptionQueryService
  ) {
    this.memberId$ = this.user$.pipe(
      filter(user => user && !!user.permitNumber),
      mergeMap(user => this.inscriptionQueryService.getMemberIdByPermitNumber(user.permitNumber)),
    );
  }

}
